export default __webpack_public_path__ + "static/media/21.e7a8aef1.jpg";